var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.setPhotoViewer,{tag:"div",attrs:{"srcs":_vm.photoimages,"showcount":5,"margin":25,"showDescript":true,"topic":_vm.topic}})}
var staticRenderFns = []

export { render, staticRenderFns }